import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button, Highchartscomponent} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';
import Highcharts from 'highcharts';



Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});
const options = {
  chart: {
      type: 'column'
  },
  title: {
      text: ''
  },
  xAxis: {
      categories: ['2013', '2014', '2015', '2016', '2017', '2018']
  },
  yAxis: {
      min: 0,
      title: {
          text: 'Number of events'
      }
  },
  tooltip: {
      pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
      shared: true
  },
  plotOptions: {
      column: {
          stacking: 'normal'
      }
  },
  series: [{
       name: 'IPO',
       data: [37, 11, 8, 13, 9, 2]
   }, {
      name: 'Acquisitions',
      data: [51, 61, 66, 131, 155, 64]
  }, {
      name: 'Forecasted',
      data: [0, 0, 0, 0, 0, 121]
  }]
}




export class ChapterTwentyTwo extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


      <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

      {"" }
      </Subtopic>

      <TextHolder text="Startup exits grew for the third year in a row. SEA was no different than other startup hubs in that acquisitions were the most common exit strategy. Only nine SEA startups were publicly listed in 2017 while 155 were acquired. This trend is expected to continue in 2018." />

      <TextHolder text="" />





          <Highchartscomponent source={<p>Source: <a href="https://www.crunchbase.com">Crunchbase</a>, Slush Singapore analysis</p>}  chartsText="Startup exits in SEA, 2013-2018"  options={options} notes="Notes: Forecast run-rate based on 2016-2017 growth rate; Countries represented: Singapore, Malaysia, Thailand, Philippines, Vietnam, Indonesia. 2018 IPO / acquisition count current as of June 2018."/>
          <TextHolder text="" />

          <TextHolder text="A healthy pipeline of exits points to a healthy tech ecosystem. Bikesh Lakmichand, CEO of 1337 Ventures, feels that past trend of exits via M&A will continue and may even pick up steam in the coming months:"/>

          <TextHolder text="“There have been more tech startups confident enough to embark on acquisitions. I think the challenge in valuation is the main reason for any exit delay. Not all exits will be China led. I think we shall see large global private equity firms get into the game.” "/>
          <TextHolder text="" />

          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/22.js